export default "__VITE_ASSET__CDlnoHtl__"